import { useCallback } from 'react';
import useSWR from 'swr';
import { CACHE_KEYS } from '../utils/CacheUtils.js';
export function useAdminChangelogEventsTotalCount(client, query) {
    const fetcher = useCallback(([_action, query]) => fetchChangelogEventsTotalCount(client, query), [client]);
    const { data, error } = useSWR(query ? CACHE_KEYS.adminChangelogEventsTotalCount(query) : null, fetcher);
    // useDebugLogChangedValues('useAdminChangelogEventsTotalCount changed values', { data, error });
    return { totalCount: data, totalCountError: error };
}
async function fetchChangelogEventsTotalCount(client, query) {
    const result = await client.getChangelogEventsTotalCount(query);
    if (result.isError()) {
        throw result; // throw result, don't convert to Error
    }
    return result.value;
}
//# sourceMappingURL=useAdminChangelogEventsTotalCount.js.map